export default {
    computed: {
        mascaraPercentual () {
            return {
                mask: ['UZZ,ZZ', 'FF,FF', 'F,FF'],
                //'FFV'
                tokens: {
                    F: {
                        pattern : /[0-9]/
                    },
                    U: {
                        pattern : /1/
                    },
                    Z: {
                        pattern : /0/
                    },
                    V: {
                        pattern : /,/
                    }                    
                },
                masked: false
            }
        },
    },
}
